export const TABS_OPTIONS = [
  { id: 1, tabName: 'INITIAL', keyName: 'initial' },
  { id: 2, tabName: 'MEDIAL', keyName: 'medial' },
  { id: 3, tabName: 'FINAL', keyName: 'final' },
];

export const WORTART = [
  { id: 1, name: 'Nomen', value: 'nomen' },
  { id: 2, name: 'Verb', value: 'verb' },
  { id: 3, name: 'Adjektiv', value: 'adjektiv' },
  { id: 4, name: 'Zahlwort', value: 'zahlenwort' },
  { id: 5, name: 'Floskel', value: 'floskel' },
];

export const BASIC_CHECK_BOX = {
  default: [
    {
      name: 'Silbenanzahl',
      values: [1, 2, 3, 4, 5],
    },
    {
      name: 'Silbenstruktur',
      values: ['einfach', 'komplex', null, null, null],
    },
    {
      name: 'Wortakzent',
      values: [1, 2, 3, 4, 5],
    },
    {
      name: 'Wortfrequenz',
      values: ['hoch', 'niedrig', null, null, null],
    },
  ],
  floskel: [
    {
      name: 'Silbenanzahl',
      values: [1, 2, 3, 4, 5],
    },
    {
      name: 'Silbenstruktur',
      values: ['einfach', 'komplex', null, null, null],
    },
  ],
  nomen: [
    {
      name: 'Silbenanzahl',
      values: [1, 2, 3, 4, 5],
    },
    {
      name: 'Silbenstruktur',
      values: ['einfach', 'komplex', null, null, null],
    },
    {
      name: 'Wortakzent',
      values: [1, 2, 3, 4, 5],
    },
    {
      name: 'Wortfrequenz',
      values: ['hoch', 'niedrig', null, null, null],
    },
    {
      name: 'Genus',
      values: [
        { value: 'männlich', display: 'maskulin' },
        { value: 'weiblich', display: 'feminin' },
        { value: 'neutrum', display: 'neutral' },
        null,
        null,
      ],
    },
    {
      name: 'Numerus',
      values: [
        { value: 0, display: 'Singular' },
        { value: 1, display: 'Plural' },
        null,
        null,
        null,
      ],
    },
  ],
};

export const TAB_PHONEMAUSWAHL_DATA = {
  1: 'INITIAL',
  2: 'MEDIAL',
  3: 'FINAL',
};

export const PHONEMAUSWAHL_DATA = {
  INITIAL: {
    title: 'Welche Laute sollen am Wortanfang vorkommen?',
    selectAllText: 'Alle initialen Phoneme',
    Vokale: ['a', 'e', 'i', 'o', 'u', 'ä', 'ö', 'ü', 'au', 'ei', 'eu'],
    Plosive: ['p', 'b', 't', 'd', 'k', 'g'],
    Frikative: ['f', 'w', 's (stl)', 's (sth)', 'sch', 'h', 'ch1', 'pf', 'ts'],
    Nasale: ['m', 'n'],
    Weitere: ['r', 'l', 'j'],
  },
  MEDIAL: {
    title: 'Welche Laute sollen in der Wortmitte vorkommen?',
    selectAllText: 'Alle medialen Phoneme',
    Vokale: ['a', 'e', 'i', 'o', 'u', 'ä', 'ö', 'ü', 'schwa', 'au', 'ei', 'eu'],
    Plosive: ['p', 'b', 't', 'd', 'k', 'g'],
    Frikative: [
      'f',
      'w',
      's (stl)',
      's (sth)',
      'sch',
      'h',
      'ch1',
      'ch2',
      'pf',
      'ts',
    ],
    Nasale: ['m', 'n', 'ng'],
    Weitere: ['r', 'l', 'j'],
  },
  FINAL: {
    title: 'Welche Laute sollen am Wortende vorkommen?',
    selectAllText: 'Alle finalen Phoneme',
    Vokale: ['a', 'e', 'i', 'o', 'u', 'ä', 'ö', 'ü', 'schwa', 'au', 'ei', 'eu'],
    Plosive: ['p', 't', 'k'],
    Frikative: ['f', 's (stl)', 'sch', 'ch1', 'ch2', 'pf', 'ts'],
    Nasale: ['m', 'n', 'ng'],
    Weitere: ['l'],
  },
};

export const getData = (activeTab) => {
  const tabName = TAB_PHONEMAUSWAHL_DATA[activeTab];
  const data = PHONEMAUSWAHL_DATA[tabName];
  return data;
};
